import React from "react";
import Switch from "@material-ui/core/Switch";

import useStyles from "../styles";

function SwitchOwnProduct({ value, label, setValue, isEnable }) {
    const classes = useStyles();

    const handleChange = event => {
        setValue(event.target.checked);
    };

    return (
        <div>
            <label className={classes.label} >{label}</label>
            <div className={classes.divSwitch}>
                <p style={{marginRight:"8px", fontSize: "16px",}}>No</p>
                <Switch
                    checked={value}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                    disabled={isEnable ?? false}
                />
                <p style={{marginLeft:"8px", fontSize: "16px",}}>Si</p>
            </div>
        </div>
    );
}

export default SwitchOwnProduct;